import { __ } from '@wordpress/i18n';

const PreviewFieldContent = ({ field, area }) => {
  switch (field.type) {
    case 'image':
      if (area === 'avatar') {
        return (
          <div className="hvnly--builder---api_property__builder___single_page_card_avatar">
            <i className="fas fa-user"></i>
          </div>
        );
      }
      return (
        <div className="hvnly--builder---api_property__builder___preview_card_image_bg">
          <i className="fas fa-image"></i>
        </div>
      );
    case 'carousel':
      return (
        <div className="hvnly--builder---api_property__builder___preview_card_image_bg">
          <i className="fas fa-images"></i>
        </div>
      );
    case 'badge':
      return <span className="hvnly--builder---api_property__builder___preview_card_tag">{field.value?.text}</span>;
    case 'favorite':
      return <i className={`fas fa-heart ${field.value?.isFavorite ? 'active' : ''}`}></i>;
    case 'title':
      return <h3 className="hvnly--builder---api_property__builder___preview_card_title">{field.value?.text}</h3>;
    case 'rating':
      return (
        <div className="hvnly--builder---api_property__builder___preview_card_rating">
          {[...Array(5)].map((_, i) => (
            <i key={i} className={`fas fa-star ${i < Math.floor(field.value?.value || 0) ? 'filled' : ''}`}></i>
          ))}
          <span>{field.value?.value} ({__('120 reviews', 'havenlytics')})</span>
        </div>
      );
    case 'phone':
      return (
        <div className="hvnly--builder---api_property__builder___single_page_card_detail_item">
          <i className="fas fa-phone"></i>
          <span>{field.value?.number}</span>
        </div>
      );
    case 'email':
      return (
        <div className="hvnly--builder---api_property__builder___single_page_card_detail_item">
          <i className="fas fa-envelope"></i>
          <span>{field.value?.address}</span>
        </div>
      );
    case 'website':
      return (
        <div className="hvnly--builder---api_property__builder___single_page_card_detail_item">
          <i className="fas fa-globe"></i>
          <span>{field.value?.url}</span>
        </div>
      );
    case 'datetime':
      return (
        <div className="hvnly--builder---api_property__builder___single_page_card_detail_item">
          <i className="fas fa-clock"></i>
          <span>{field.value?.text}</span>
        </div>
      );
    case 'property_type':
    return field.value?.text || __('Property Type', 'havenlytics');
    case 'views':
      return (
        <div className="hvnly--builder---api_property__builder___preview_card_views">
          <i className="fas fa-eye"></i>
          <span>{field.value?.count || 0} {__('views', 'havenlytics')}</span>
        </div>
      );
    case 'price':
      return `$${field.value?.value || '0'}`;
    case 'price-per-sqft':
      return `$${field.value?.value || '0'}/sq ft`;
    case 'beds':
      return `${field.value?.value || '0'} ${__('Beds', 'havenlytics')}`;
    case 'baths':
      return `${field.value?.value || '0'} ${__('Baths', 'havenlytics')}`;
    case 'receptions':
      return `${field.value?.value || '0'} ${__('Receptions', 'havenlytics')}`;
    case 'sqft':
      return `${field.value?.value || '0'} ${__('Sq ft', 'havenlytics')}`;
    case 'kitchens':
      return `${field.value?.value || '0'} ${__('Kitchens', 'havenlytics')}`;
    case 'floor':
      return `${field.value?.value || '0'} ${__('Floor', 'havenlytics')}`;
    case 'rooms':
      return `${field.value?.value || '0'} ${__('Rooms', 'havenlytics')}`;
    case 'gsft':
      return `${field.value?.value || '0'} ${__('Gsq ft', 'havenlytics')}`;
    case 'view-btn':
      if (area === 'footer-left') {
        return `${field.value?.text || __('View Property', 'havenlytics')}`;
      }
      return field.value?.text || __('View Property', 'havenlytics');
    case 'schedule-tour-button':
      if (area === 'footer-left') {
        return `${field.value?.text || __('Schedule Tour', 'havenlytics')}`;
      }
      return field.value?.text || __('Schedule Tour', 'havenlytics');
    case 'feature':
      return (
        <>
          <i className={`fas fa-${field.value?.icon || 'star'}`}></i> {field.value?.label || __('Feature', 'havenlytics')}
        </>
      );
    case 'excerpt':
      return field.value?.text || __('Excerpt', 'havenlytics');
    case 'location':
      return field.value?.text || __('Location', 'havenlytics');
    case 'status':
      return `${field.value?.text || __('Status', 'havenlytics')}`;
    case 'time':
      return `${field.value?.text || __('Time', 'havenlytics')}`;
    default:
      return <span>{field.value?.text || field.label}</span>;
  }
};

export default PreviewFieldContent;